var BlockView = require('views/block/base-block-view');
const AhoyService = require('services/ahoy-service');

/***
 * @View
 *
 * @name email
 * @type block
 * @description Email block
 * @content
 *  @prop @required label type={string} title="Email label" description="Email label text"
 *  @prop @advanced homeroom_email_template type={string} title="Template" description="Homeroom Email Template"
 *  @prop @advanced button_class type={string} title="Button Class" description="CSS Class(es) for button"
 *  @prop @advanced email_form_class type={string} description="CSS Class(es) for email form"
 */
var EmailView = BlockView.extend({
  load: function () {
    this.delegate('click', '.email-button', function () {
      Backbone.ajax({
        type: 'POST',
        url: EF.url(`/sdk/enrollments/${EF.enrollment.get('id')}/course_messages/email.json`),
        data: { email: this.$el.find('#email_input').val(), template: this.model.get('homeroom_email_template'), module_key: EF.module.get('key') },
        success: function () {
          AhoyService.track('email', { action: 'submit email', status: 'success' });
          Chaplin.mediator.publish(
            'action:alert',
            'success',
            'Email submitted successfully.',
            '',
            '',
            true);
          $('.modal').modal('hide');
        },
        error: function (jqXHR, exception) {
          AhoyService.track('email', { action: 'email submitted', status: 'error' });
          Chaplin.mediator.publish(
            'action:alert',
            'error',
            'An error occurred while submitting your email, please try again.',
            exception,
            '',
            true);
          $('.modal').modal('hide');
        }
      });
    });
  },
  play: function () {
    this.readyToGo();
  }
});

module.exports = EmailView;
